'use strict';

import toasts from '../toast-notify';

function initOrderCancel() {
    const $modal = $('#order-cancellation-modal');

    if (!$modal.length) return;

    const modalElement = $modal[0];

    const popup = new Foundation.Reveal($('#order-cancellation-modal'));

    let isProcessing = false;
    let activeTrigger = null;
    let backgroundStates = [];

    const stateDescriptions = {
        confirmation: [
            'order-cancellation-message',
            'order-cancellation-detail'
        ],
        contact: [
            'order-cancellation-contact-message',
            'order-cancellation-contact-detail'
        ],
        retry: [
            'order-cancellation-retry-message',
            'order-cancellation-retry-detail'
        ]
    };

    function getTrigger() {
        return $('.js-cancel-order-btn');
    }

    function focusElement(element) {
        if (!element || !element.isConnected) return;
        // Make programmatic focus reliable for links/buttons.
        element.focus({ preventScroll: true });
    }

    function focusCloseButton() {
        focusElement(modalElement.querySelector('.close-button'));
    }

    function focusReturnTarget() {
        const trigger = getTrigger();

        if (trigger.length) {
            focusElement(trigger[0]);
            return;
        }
    }

    function setBackgroundInert(enabled) {
        if (enabled) {
            backgroundStates = [];

            Array.from(document.body.children).forEach((element) => {
                // Keep the modal overlay and its contents interactive.
                const isModalOverlay =
                    element.classList.contains('reveal-overlay');

                if (isModalOverlay) return;

                backgroundStates.push({
                    element,
                    wasInert: element.inert
                });

                element.inert = true;
            });

            return;
        }

        backgroundStates.forEach(({ element, wasInert }) => {
            if (element.isConnected) {
                element.inert = wasInert;
            }
        });

        backgroundStates = [];
    }

    function setDescription(stateName) {
        const ids = stateDescriptions[stateName];

        if (!ids) return;

        modalElement.setAttribute('aria-describedby', ids.join(' '));

        Object.keys(stateDescriptions).forEach((name) => {
            const $state = $modal.find('.js-modal-state-' + name);
            $state.prop('hidden', name !== stateName);
        });
    }

    function setButtonsDisabled(disabled) {
        $modal.find(
            '.js-confirm-order-cancellation, .js-keep-order, .close-button'
        ).prop('disabled', disabled);

        isProcessing = disabled;

        $modal.toggleClass('is-processing', disabled);
    }

    function showModalState(stateName) {
        setDescription(stateName);

        // Update aria-hidden before moving focus into the dialog.
        modalElement.setAttribute('aria-hidden', 'false');

        popup.open();
        // Foundation can perform its own focus work during opening.
        // Move focus to Close after its opening handlers have run.
        window.requestAnimationFrame(() => {
            focusCloseButton();
        });
    }

    function openConfirmation(event) {
        event.preventDefault();

        if (isProcessing) return;

        activeTrigger = event.currentTarget;

        setButtonsDisabled(false);
        setDescription('confirmation');

        showModalState('confirmation');
    }

    function closeModalAndRestoreFocus() {
        if (isProcessing) return;

        modalElement.setAttribute('aria-hidden', 'true');

        popup.close();
        setBackgroundInert(false);

        // Run after Foundation's close handlers, which may move focus.
        window.requestAnimationFrame(() => {
            focusReturnTarget();
        });
    }

    function setCancellingState($button, loading) {
        if (loading) {
            $button.text(
                $button.attr('data-loading-label') || 'Cancelling...'
            );
        } else {
            $button.text($button.data('original-text') || '');
        }
    }

    function submitOrderCancellation($button) {
        if (isProcessing) return;

        const $trigger = $('.js-cancel-order-btn').first();

        if (!$trigger.length) return;

        const url = $trigger.attr('data-url');

        const orderData = {
            orderID: $trigger.attr('data-order-id'),
            orderToken: $trigger.attr('data-order-token')
        };

        // Include CSRF data as required by your SFCC endpoint.
        const csrfName = $trigger.attr('data-csrf-name');
        const csrfToken = $trigger.attr('data-csrf-token');

        if (csrfName && csrfToken) {
            orderData[csrfName] = csrfToken;
        }

        $modal.find('.js-confirm-order-cancellation').each(function () {
            const $btn = $(this);

            if (!$btn.data('original-text')) {
                $btn.data('original-text', $btn.text().trim());
            }
        });

        const $keepButton = $modal.find('.js-keep-order');

        if (!$keepButton.data('original-text')) {
            $keepButton.data('original-text', $keepButton.text().trim());
        }

        setButtonsDisabled(true);
        setCancellingState($button, true);

        $.ajax({
            url,
            method: 'POST',
            data: orderData,
            dataType: 'json'
        })
        .done(function (data) {
            setButtonsDisabled(false);

            if (data && data.success && data.scenario === 'SUCCESS') {
                handleSuccess();
            } else if (data && data.scenario === 'CONTACT') {
                // The order can no longer be cancelled.
                $trigger.remove();
                updateStatusAfterBlock(data);
                handleOutcome('contact');
            } else {
                handleOutcome('retry', data);
                setCancellingState($button, false);
            }
        })
        .fail(function () {
            setButtonsDisabled(false);
            handleOutcome('retry');
        });
    }

    function handleOutcome(stateName, data) {
        setDescription(stateName);

        // Optional: use trusted server response fields to distinguish
        // a retryable failure from a cooling-off-expired outcome.
        if (stateName === 'retry' && data && data.retryAllowed === false) {
            $modal.find('.js-confirm-order-cancellation')
                .filter(':visible')
                .remove();
        }

        showModalState(stateName);

        // Repeated failures must announce the state again.
        // Resetting focus on every outcome ensures the message is revisited.
        window.requestAnimationFrame(() => {
            focusCloseButton();
        });
    }

    function handleSuccess() {
        // Update the visible status as text, not only by changing its colour.
        const $status = $('.js-order-status-value');

        if ($status.length) {
            const cancelledLabel =
                $status.attr('data-cancelled-label') || 'Cancelled';

            $status.text(cancelledLabel);
        }

        // The trigger is no longer available after successful cancellation.
        $('.js-open-order-cancellation').remove();

        modalElement.setAttribute('aria-hidden', 'true');
        popup.close();
        setBackgroundInert(false);

        // Announce the successful cancellation to assistive technologies.
        window.requestAnimationFrame(() => {

            window.requestAnimationFrame(() => {
                announceSuccess();
            });
        });
        $(".order-status-notice").hide();
    }

    function updateStatusAfterBlock(data) {
        if (!data || !data.orderStatusLabel) return; // race case: no label, page refreshes on reload

        // .text() keeps it encoded, same as <isprint> on page load
        $('.js-order-status-value').text(data.orderStatusLabel);

        // Switch the header message from "created" to "not created"
        $('.js-status-msg-created').prop('hidden', true);
        $('.js-status-msg-notcreated').prop('hidden', false);
    }

    function announceSuccess() {
        const message = $('.js-order-cancellation-copy [data-copy="success-message"]').text().trim();
        toasts.init(message, 'active cancel-order-toast animate__fadeInDownToast', 'icon-close');
        // Announce success through a persistent live region.
        const $announcer = $('.js-order-cancellation-announcer');

        if (!$announcer.length || !message) return;

        // Clear the previous message to support repeated announcements.
        $announcer.text('');

        window.setTimeout(() => {
            $announcer.text(message);
        }, 1000);
    }
    
    // Trigger opens the confirmation dialog.
    $(document).on('click', '.js-open-order-cancellation', openConfirmation);

    // Confirm / Try again.
    $modal.on('click', '.js-confirm-order-cancellation', function (event) {
        event.preventDefault();

        if (isProcessing || this.disabled) return;

        const $button = $(this);

        if (!$button.data('original-text')) {
            $button.data('original-text', $button.text().trim());
        }
        
        submitOrderCancellation($button);
    });

    // Keep my order / Back to my order.
    $modal.on('click', '.js-keep-order, .js-back-to-order', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (isProcessing) return;

        closeModalAndRestoreFocus();
    });

    // Close X.
    $modal.on('click', '.close-button', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (isProcessing) return;

        closeModalAndRestoreFocus();
    });

    // Trap focus inside the dialog.
    $modal.on('keydown', function (event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (!isProcessing) {
                closeModalAndRestoreFocus();
            }

            return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(
            modalElement.querySelectorAll(
                'button:not(:disabled):not([hidden]), ' +
                'a[href]:not([hidden]), '
            )
        ).filter((element) => {
            return element.getClientRects().length > 0 &&
                !element.closest('[hidden]');
        });

        if (!focusable.length) {
            event.preventDefault();
            modalElement.focus();
            return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (
            !event.shiftKey &&
            document.activeElement === last
        ) {
            event.preventDefault();
            first.focus();
        }
    });

    // Prevent outside pointer clicks from dismissing the dialog.
    $(document).on('click', '.reveal-overlay', function (event) {
        if (event.target !== this || isProcessing) return;

        event.preventDefault();
        event.stopPropagation();
    });

    // Ensure focus stays within the modal while open.
    $modal.on('open.zf.reveal', function () {
        setBackgroundInert(true);
        modalElement.setAttribute('aria-hidden', 'false');
        window.requestAnimationFrame(focusCloseButton);
    });

    $modal.on('closed.zf.reveal', function () {
        modalElement.setAttribute('aria-hidden', 'true');
        setBackgroundInert(false);
        window.location.reload();
    });

    // Prevent accidental close attempts from other code while processing.
    $modal.on('close.zf.reveal', function (event) {
        if (isProcessing) {
            event.preventDefault();
            event.stopPropagation();
        }
    });
}

export default {
    init: function () {
        initOrderCancel();
    }
};
